import styled from "styled-components";
import { useField, useFormikContext } from "formik";

// utils
import { getCalendar } from "utils/date";

const periodOptions = [
  {
    value: "TODAY",
    label: "오늘",
  },
  {
    value: "YESTERDAY",
    label: "어제",
  },
  {
    value: "WEEK",
    label: "1주일",
  },
  {
    value: "CURRENT_MONTH",
    label: "당월",
  },
  {
    value: "LAST_MONTH",
    label: "전월",
  },
];

const SelectPeriodType = ({ ...props }) => {
  const [field, { value }, { setValue }] = useField(props);
  const { setFieldValue } = useFormikContext();
  const isSelected = (selected) => (selected === value ? "selected" : "");

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setValue(value);

    const d = new Date();
    let startDt = null;
    let endDt = null;

    switch (value) {
      case "TODAY":
        startDt = getCalendar(d);
        endDt = getCalendar(d);
        break;

      case "YESTERDAY":
        const yesterday = new Date(d.setDate(d.getDate() - 1));
        startDt = getCalendar(yesterday);
        endDt = getCalendar(yesterday);
        break;

      case "WEEK":
        const startDateOfLastWeek = new Date(d.setDate(d.getDate() - 7));
        startDt = getCalendar(startDateOfLastWeek);
        endDt = getCalendar(new Date());
        break;

      case "CURRENT_MONTH":
        startDt = getCalendar(d.getStartDateInMonth());
        endDt = getCalendar(new Date(d.getFullYear(), d.getMonth() + 1, 0));
        break;

      case "LAST_MONTH":
        startDt = getCalendar(new Date(d.getFullYear(), d.getMonth() - 1, 1));
        endDt = getCalendar(new Date(d.getFullYear(), d.getMonth(), 0));
        break;

      default:
        return;
    }

    setFieldValue("startDt", startDt);
    setFieldValue("endDt", endDt);
  };

  const renderOptions = () => {
    return periodOptions.map((option) => {
      return (
        <Option
          type="button"
          key={option.value}
          value={option.value}
          className={isSelected(option.value)}
          onClick={handleChange}
        >
          {option.label}
        </Option>
      );
    });
  };

  return <ButtonsWrapper>{renderOptions()}</ButtonsWrapper>;
};

const ButtonsWrapper = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  button:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  button:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  button:not(:last-child) {
    border-right: none;
  }
`;

const Option = styled.button`
  flex: 1;
  height: inherit;
  background-color: inherit;
  color: #70747d;
  font-size: 16px;
  line-height: 24px;
  border: 1px solid #e0e1e8;


  &.selected {
    color: #004fec;
    border-color: #004fec;
    border-left-color: #004fec;
  }
  &.selected + button {
    border-left-color: #004fec;
  }
`;

export default SelectPeriodType;
